import { render, staticRenderFns } from "./LiveTimeAgo.vue?vue&type=template&id=f2fa5f16&"
import script from "./LiveTimeAgo.vue?vue&type=script&lang=ts&"
export * from "./LiveTimeAgo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports